import Loading from "components/Loading";
import { useState } from "react";
import { Container, Row, Col, Nav, Button, Form, Alert } from "react-bootstrap";
import api from "utils/axiosInstance";

const Sidebar = ({ onSelect }) => {
  return (
    <Nav className="flex-column navbar-sph p-3 vh-100">
      <h4 className="mb-4">Dashboard</h4>
      <Nav.Link onClick={() => onSelect("addUser")}>Add User</Nav.Link>
      <Nav.Link onClick={() => onSelect("checkReports")}>
        Check Reports
      </Nav.Link>
    </Nav>
  );
};

const AddUser = () => {
  const [error, setError] = useState({ state: false, message: "" });
  const [success, setSuccess] = useState({ state: false, message: "" });
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    subjectId: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const toggleError = () => {
    setError({ state: false, message: "" });
  };

  const toggleSuccessMessage = () => {
    setSuccess({ state: false, message: "" });
  };

  const createUser = async () => {
    setLoading(true);

    var subjectIdRegex = /^HERO\d{3,4}$/;
    if (
      !formData.subjectId?.trim() ||
      !subjectIdRegex.test(formData.subjectId)
    ) {
      alert("User ID is required and must have HERO followed by the REDCap ID");
      setLoading(false);
      return;
    }

    try {
      const response = await api({
        method: "post",
        url: "/user/create",
        data: {
          userId: formData.subjectId,
          email: formData.email,
          givenName: formData.firstName,
          familyName: formData.lastName,
          role: 1,
        },
        headers: {
          "Content-Type": "application/json",
        },
      });
      toggleError();
      if (response.status === 201) {
        setSuccess({
          state: true,
          message:
            "User Created Successfully. Check their email address for a temporary password",
        });
      } else {
        setError({
          state: true,
          message: response.data,
        });
      }
    } catch (err) {
      if (err.response && err.response.data)
        setError({ state: true, message: err.response.data });
    }
    setLoading(false);
  };

  if (loading) return <Loading />;

  return (
    <>
      {error.state && (
        <Alert variant="danger" onClose={toggleError} className="my-3">
          <strong>Error:</strong> {error.message}
        </Alert>
      )}
      {success.state && (
        <Alert variant="success" onClose={toggleSuccessMessage} dismissible>
          {success.message}
        </Alert>
      )}
      <Form onSubmit={createUser}>
        <Alert variant="info">
          Please note that the subject has to be created in REDCap first and
          randomization form for the subject should be filled before filling out
          this form
        </Alert>
        <Form.Group className="mb-3">
          <Form.Label>First Name</Form.Label>
          <Form.Control
            type="text"
            name="firstName"
            value={formData.firstName}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Last Name</Form.Label>
          <Form.Control
            type="text"
            name="lastName"
            value={formData.lastName}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Email Address</Form.Label>
          <Form.Control
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Subject ID</Form.Label>
          <Form.Control
            type="text"
            name="subjectId"
            value={formData.subjectId}
            onChange={handleChange}
            required
          />
        </Form.Group>

        <Button variant="primary" onClick={createUser}>
          Create Subject
        </Button>
      </Form>
    </>
  );
};

const CheckReports = () => (
  <div>
    <h2>Check Reports</h2>
    <p>Reports will be displayed here.</p>
  </div>
);

function UserManagement() {
  const [selectedOption, setSelectedOption] = useState("addUser");

  return (
    <Container>
      <AddUser />
    </Container>
  );
}

export default UserManagement;
